import { useTranslation } from 'react-i18next';

export function AudienceSection() {
  const { t } = useTranslation();

  const groups = [
    t('about.audience.groups.0'),
    t('about.audience.groups.1'),
    t('about.audience.groups.2'),
    t('about.audience.groups.3'),
    t('about.audience.groups.4'),
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Photo Column */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=diverse%20group%20of%20happy%20people%20achieving%20fitness%20and%20nutrition%20goals%20smiling%20confident%20healthy%20lifestyle%20different%20ages%20and%20backgrounds%20celebrating%20success%20natural%20lighting%20professional%20portrait%20photography&width=800&height=1000&seq=about-audience-lifestyle-nutribot&orientation=portrait"
                alt="Diverse people achieving nutrition goals"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              
              {/* Floating Stat Card */}
              <div className="absolute bottom-6 right-6 bg-gray-900 border-2 border-yellow-500 rounded-xl p-6 shadow-2xl hidden sm:block">
                <div className="text-center">
                  <div className="text-4xl font-bold text-yellow-400 mb-2">10k+</div>
                  <div className="text-sm text-gray-300 font-medium whitespace-nowrap">{t('about.happyUsers')}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-yellow-400/10 rounded-lg">
                <i className="ri-team-line text-2xl text-yellow-400"></i>
              </div>
              <h2 className="text-4xl sm:text-5xl font-bold text-white">
                {t('about.audience.title')}
              </h2>
            </div>
            
            <p className="text-yellow-400 text-xl sm:text-2xl font-semibold mb-8">
              {t('about.audience.subtitle')}
            </p>

            <div className="space-y-4 mb-8">
              {groups.map((group, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-fill text-2xl text-yellow-400"></i>
                  </div>
                  <p className="text-gray-300 text-lg leading-relaxed">{group}</p>
                </div>
              ))}
            </div>

            <p className="text-white text-xl font-semibold">
              {t('about.audience.closing')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
